import React, { useCallback, useMemo } from "react";
import Header from "../../layout/Header";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import SpinImageHi from "../../../assets/images/I Won Cashback_WA Share_Hindi.gif";
import SpinImageMr from "../../../assets/images/I Won Cashback_WA Share_Marathi.gif";
import SpinImageTe from "../../../assets/images/I Won Cashback_WA Share_Telugu.gif";
import SpinImageKa from "../../../assets/images/spinImage_ka.png";
import SpinImagePb from "../../../assets/images/spinImage_pb.png";
import SpinImageGj from "../../../assets/images/spinImage_gj.png";
import SpinImageTa from "../../../assets/images/spinImage_ta.png";
import SpinImageBn from "../../../assets/images/spinImage_ba.png";
import SpinImageEn from "../../../assets/images/spinImage_en.png";
import SpinImageMa from "../../../assets/images/spinImage_ma.png";


const pickSpinCreative = (lang) => {
    switch (lang) {
        case "mr":
            return SpinImageMr;
        case "kn":
            return SpinImageHi;
        case "te":
            return SpinImageTe;
        case "pa":
            return SpinImageHi;
        case "gu":
            return SpinImageHi;
        case "ta":
            return SpinImageHi;
        case "bn":
            return SpinImageHi;
        case "en":
            return SpinImageHi;
        case "ma":
            return SpinImageHi;
        default:
            return SpinImageHi;
    }
};

export const AwardShare = () => {
    const { t } = useTranslation();
    const { lang } = useParams();

    const creativeSrc = useMemo(() => pickSpinCreative(lang), [lang]);

    const handleShareNow = useCallback(async () => {
        const text = t("shareText");

        try {
            const response = await fetch(creativeSrc);
            if (!response.ok) throw new Error("image fetch failed");
            const blob = await response.blob();
            const ext =
                blob.type?.includes("png") ? "png" : blob.type?.includes("jpeg") ? "jpg" : "png";
            const mime = blob.type || "image/png";
            const file = new File([blob], `strongarm-cashback.${ext}`, {
                type: mime,
            });
            const withFiles = { files: [file], title: t("Share"), text };
            if (navigator.canShare && navigator.canShare(withFiles)) {
                await navigator.share(withFiles);
                return;
            }
        } catch (_) {
            /* fall through */
        }

        try {
            if (navigator.share) {
                await navigator.share({
                    text,
                    url: window.location.href,
                    title: t("Share"),
                });
            }
        } catch (e) {
            if (e?.name !== "AbortError") {
                window.alert(
                    t("shareNotSupported", {
                        defaultValue:
                            "Sharing is not supported in this browser. Try Chrome or Safari on a phone.",
                    })
                );
            }
        }
    }, [creativeSrc, t]);

    return (
        <>
            <Header />
            <div className="main pb-5">
                <div className="container py-3" style={{ maxWidth: 420, margin: "0 auto" }}>
                    <div
                        style={{
                            
                           
                          
                            background: "#fff",
                            aspectRatio: "298 / 386",
                            width: "100%",
                            
                            margin: "0 auto",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxSizing: "border-box",
                        }}
                    >
                        <img
                            src={creativeSrc}
                            alt=""
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                display: "block",
                            }}
                        />
                    </div>
                    {/* <p  style={{ whiteSpace: "pre-line" }}
                        className="text-center text-muted small mt-2 mb-0 px-2"
                        style={{ fontSize: 11 }}
                    >
                        {t("shareCreativeHint", {
                            defaultValue: t('shareMessage'),
                        })}
                    </p> */}
                    <button
                        type="button"
                        className="btn btn-primary w-100 py-3 center-textbtn mt-4 mb-5 text-white claimBtn rounded-4 btnshadow"
                        style={{ boxShadow: "0 4px 12px rgba(34, 166, 63, 0.35)" }}
                        onClick={handleShareNow}
                    >
                        {t("shareNow", {
                            defaultValue: t("ShareNow"),
                        })}
                    </button>
                </div>
            </div>
        </>
    );
};
